/* === TYPEWRITER CLICK SOUND === */
let audioCtx = null;

function getAudioContext() {
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return null;
    }
  }
  return audioCtx;
}

function playClick() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const ctx = getAudioContext();
  if (!ctx) return;

  try {
    if (ctx.state === 'suspended') ctx.resume();

    const sampleRate = ctx.sampleRate;
    const bufferSize = Math.floor(sampleRate * 0.045);
    const buffer = ctx.createBuffer(1, bufferSize, sampleRate);
    const data = buffer.getChannelData(0);

    for (let i = 0; i < bufferSize; i++) {
      const t = i / bufferSize;
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 5) * 0.9;
    }

    const source = ctx.createBufferSource();
    source.buffer = buffer;

    const bandpass = ctx.createBiquadFilter();
    bandpass.type = 'bandpass';
    bandpass.frequency.value = 2200;
    bandpass.Q.value = 0.8;

    const highpass = ctx.createBiquadFilter();
    highpass.type = 'highpass';
    highpass.frequency.value = 600;

    const gain = ctx.createGain();
    gain.gain.value = 0.38;

    source.connect(highpass);
    highpass.connect(bandpass);
    bandpass.connect(gain);
    gain.connect(ctx.destination);
    source.start();
  } catch (e) {
    // fail silently
  }
}

document.addEventListener('mousedown', function (e) {
  const target = e.target.closest(
    '.product-card, button, .nav-link, [data-click-sound], .cart-item__remove, .mobile-nav__link'
  );
  if (target) playClick();
});


/* === AJAX ADD TO CART === */
const addToCartForm = document.getElementById('add-to-cart-form');
const addToCartBtn  = document.getElementById('add-to-cart-btn');

if (addToCartForm && addToCartBtn) {
  const originalLabel = addToCartBtn.textContent.trim();

  addToCartForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData  = new FormData(addToCartForm);
    const variantId = formData.get('id');
    const quantity  = parseInt(formData.get('quantity'), 10) || 1;

    if (!variantId) return;

    addToCartBtn.disabled    = true;
    addToCartBtn.textContent = '. . .';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.json();
      })
      .then(function () {
        addToCartBtn.textContent = 'ADDED —';
        updateCartCount();
        setTimeout(function () {
          if (window.openCartDrawer) window.openCartDrawer();
        }, 300);
        setTimeout(function () {
          addToCartBtn.textContent = originalLabel;
          addToCartBtn.disabled    = false;
        }, 2200);
      })
      .catch(function () {
        addToCartBtn.textContent = 'TRY AGAIN';
        addToCartBtn.disabled    = false;
        setTimeout(function () {
          addToCartBtn.textContent = originalLabel;
        }, 2200);
      });
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = 'CART [' + cart.item_count + ']';
      });
    })
    .catch(function () {});
}


/* === CURRENCY PICKER
   Uses flag-icons CSS library (<span class="fi fi-xx">) instead of emoji —
   emoji flags are not supported on Windows and show as two-letter codes.     === */
var CURRENCY_COUNTRY = {
  // Americas
  USD: 'us', CAD: 'ca', MXN: 'mx', BRL: 'br', ARS: 'ar',
  CLP: 'cl', COP: 'co', PEN: 'pe', UYU: 'uy', PYG: 'py',
  BOB: 'bo', VES: 've', GYD: 'gy', SRD: 'sr', TTD: 'tt',
  JMD: 'jm', BBD: 'bb', BSD: 'bs', BZD: 'bz', HTG: 'ht',
  HNL: 'hn', GTQ: 'gt', NIO: 'ni', CRC: 'cr', DOP: 'do',
  PAB: 'pa', AWG: 'aw', KYD: 'ky', XCD: 'ag', BMD: 'bm',

  // Europe
  EUR: 'eu', GBP: 'gb', CHF: 'ch', SEK: 'se', NOK: 'no',
  DKK: 'dk', PLN: 'pl', CZK: 'cz', HUF: 'hu', RON: 'ro',
  BGN: 'bg', HRK: 'hr', RSD: 'rs', ISK: 'is', UAH: 'ua',
  BAM: 'ba', MKD: 'mk', MDL: 'md', ALL: 'al', RUB: 'ru',
  GEL: 'ge', AMD: 'am', AZN: 'az', BYN: 'by', TRY: 'tr',

  // Middle East & North Africa
  AED: 'ae', SAR: 'sa', KWD: 'kw', QAR: 'qa', OMR: 'om',
  BHD: 'bh', JOD: 'jo', ILS: 'il', EGP: 'eg', MAD: 'ma',
  TND: 'tn', LYD: 'ly', DZD: 'dz', LBP: 'lb', IQD: 'iq',
  YER: 'ye', SYP: 'sy', SDG: 'sd',

  // Asia Pacific
  JPY: 'jp', CNY: 'cn', HKD: 'hk', SGD: 'sg', TWD: 'tw',
  KRW: 'kr', INR: 'in', PKR: 'pk', BDT: 'bd', LKR: 'lk',
  NPR: 'np', MYR: 'my', IDR: 'id', PHP: 'ph', THB: 'th',
  VND: 'vn', MMK: 'mm', KHR: 'kh', LAK: 'la', MNT: 'mn',
  KZT: 'kz', UZS: 'uz', KGS: 'kg', TMT: 'tm', AFN: 'af',
  AUD: 'au', NZD: 'nz', FJD: 'fj', PGK: 'pg', SBD: 'sb',
  TOP: 'to', VUV: 'vu', WST: 'ws', BTN: 'bt', MVR: 'mv',
  MOP: 'mo',

  // Africa
  ZAR: 'za', NGN: 'ng', KES: 'ke', GHS: 'gh', ETB: 'et',
  TZS: 'tz', UGX: 'ug', RWF: 'rw', MZN: 'mz', ZMW: 'zm',
  ZWL: 'zw', BWP: 'bw', NAD: 'na', SZL: 'sz', LSL: 'ls',
  MWK: 'mw', MGA: 'mg', MUR: 'mu', SCR: 'sc', CVE: 'cv',
  GMD: 'gm', SLL: 'sl', LRD: 'lr', GYD: 'gy', DJF: 'dj',
  KMF: 'km', BIF: 'bi', CDF: 'cd', AOA: 'ao', SOS: 'so',
  SHP: 'sh', MRO: 'mr', XAF: 'un', XOF: 'un',
};

function makeFlagEl(countryCode) {
  var span = document.createElement('span');
  span.className = 'fi fi-' + countryCode;
  return span;
}

function initCurrencyPicker() {
  var hiddenSelect = document.getElementById('currency-select-hidden');
  var btn          = document.getElementById('currency-picker-btn');
  var dropdown     = document.getElementById('currency-picker-dropdown');
  var flagSpan     = document.getElementById('currency-picker-flag');
  var codeSpan     = document.getElementById('currency-picker-code');

  if (!hiddenSelect || !btn || !dropdown) return;

  Array.from(hiddenSelect.options).forEach(function (option) {
    var code        = option.value.trim().toUpperCase();
    var countryCode = CURRENCY_COUNTRY[code];

    var item = document.createElement('div');
    item.className = 'currency-picker__option' + (option.selected ? ' is-active' : '');
    item.setAttribute('role', 'option');
    item.setAttribute('data-value', option.value);

    if (countryCode) item.appendChild(makeFlagEl(countryCode));
    item.appendChild(document.createTextNode(' ' + code));

    if (option.selected) {
      if (flagSpan && countryCode) {
        flagSpan.innerHTML = '';
        flagSpan.appendChild(makeFlagEl(countryCode));
      }
      if (codeSpan) codeSpan.textContent = ' ' + code;
    }

    item.addEventListener('click', function () {
      hiddenSelect.value = this.getAttribute('data-value');
      hiddenSelect.closest('form').submit();
    });

    dropdown.appendChild(item);
  });

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = dropdown.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    playClick();
  });

  document.addEventListener('click', function () {
    dropdown.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  });
}

document.addEventListener('DOMContentLoaded', initCurrencyPicker);


/* === MOBILE MENU === */
var hamburger   = document.getElementById('hamburger');
var mobileNav   = document.getElementById('mobile-nav');
var mobileClose = document.getElementById('mobile-nav-close');

if (hamburger && mobileNav) {
  hamburger.addEventListener('click', function () {
    var isOpen = mobileNav.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.style.overflow = isOpen ? 'hidden' : '';
    playClick();
  });
}

if (mobileClose && mobileNav) {
  mobileClose.addEventListener('click', function () {
    mobileNav.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    playClick();
  });
}


/* === CONTACT DRAWER === */
(function () {
  var openBtn   = document.getElementById('contact-drawer-open');
  var mobileBtn = document.getElementById('contact-drawer-open-mobile');
  var drawer    = document.getElementById('contact-drawer');
  var overlay   = document.getElementById('contact-overlay');
  var closeBtn  = document.getElementById('contact-drawer-close');
  if (!drawer) return;

  function openDrawer(options) {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (!options || !options.silent) playClick();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    playClick();
  }

  if (openBtn)   openBtn.addEventListener('click', openDrawer);
  if (mobileBtn) mobileBtn.addEventListener('click', function () { closeDrawer(); setTimeout(openDrawer, 50); });
  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  if (overlay)   overlay.addEventListener('click', closeDrawer);

  // Let Shopify handle the contact form normally. Ajax submissions can trigger
  // false failures because Shopify may redirect, challenge spam, or return HTML
  // that is still a successful contact submission.
  if (drawer.querySelector('[data-contact-status]')) {
    openDrawer({ silent: true });
  }
})();


/* === REVIEWS SLIDER === */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-reviews-prev], [data-reviews-next]');
  if (!btn) return;

  var section = btn.closest('.reviews-section');
  if (!section) return;

  var track = section.querySelector('[data-reviews-track]');
  if (!track) return;

  var card   = track.querySelector('.review-card');
  var amount = card ? card.offsetWidth + 24 : 344;

  if (btn.hasAttribute('data-reviews-prev')) {
    track.scrollBy({ left: -amount, behavior: 'smooth' });
  } else {
    track.scrollBy({ left: amount, behavior: 'smooth' });
  }
});


/* === STICKY HEADER SCROLL SHADOW === */
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();


/* === CART DRAWER === */
(function () {
  var openBtnDesktop = document.getElementById('cart-drawer-open');
  var openBtnMobile  = document.getElementById('cart-drawer-open-mobile');
  var drawer         = document.getElementById('cart-drawer');
  var overlay        = document.getElementById('cart-overlay');
  var closeBtn       = document.getElementById('cart-drawer-close');
  var body           = document.getElementById('cart-drawer-body');
  var footer         = document.getElementById('cart-drawer-footer');
  if (!drawer) return;

  function openCartDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    playClick();
    loadCart();
  }

  function closeCartDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    playClick();
  }

  if (openBtnDesktop) openBtnDesktop.addEventListener('click', openCartDrawer);
  if (openBtnMobile) openBtnMobile.addEventListener('click', function () {
    var mobileNav = document.getElementById('mobile-nav');
    var hamburger = document.getElementById('hamburger');
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(openCartDrawer, 60);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
  });

  function loadCart() {
    if (!body) return;
    body.innerHTML = '<div class="cart-drawer__loading">—</div>';
    if (footer) footer.style.display = 'none';
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        body.innerHTML = '<div class="cart-drawer__loading">Could not load cart.</div>';
      });
  }

  function renderCart(cart) {
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p>YOUR CART IS EMPTY</p>' +
        '<a href="/collections/all" class="btn btn--outline">SHOP NOW</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var html = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img class="cart-drawer__item-img" src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy" width="72" height="72">'
        : '<div class="cart-drawer__item-img-placeholder"></div>';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__item-variant">' + esc(item.variant_title) + '</span>'
        : '';
      html +=
        '<li class="cart-drawer__item">' +
        imgHtml +
        '<div class="cart-drawer__item-info">' +
        '<span class="cart-drawer__item-title">' + esc(item.title) + '</span>' +
        variantHtml +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<div class="cart-drawer__item-controls">' +
        '<div class="cart-drawer__qty">' +
        '<button class="cart-drawer__qty-btn" data-cart-qty data-key="' + item.key + '" data-delta="-1" type="button" aria-label="Decrease">&#8722;</button>' +
        '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
        '<button class="cart-drawer__qty-btn" data-cart-qty data-key="' + item.key + '" data-delta="1" type="button" aria-label="Increase">+</button>' +
        '</div>' +
        '<button class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" type="button">REMOVE</button>' +
        '</div></div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    if (footer) {
      footer.style.display = '';
      var subtotalEl = footer.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      var key     = qtyBtn.getAttribute('data-key');
      var delta   = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var valEl   = qtyBtn.parentElement.querySelector('.cart-drawer__qty-val');
      var newQty  = Math.max(0, parseInt(valEl ? valEl.textContent : 1, 10) + delta);
      updateLineItem(key, newQty);
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn && drawer.contains(removeBtn)) {
      updateLineItem(removeBtn.getAttribute('data-key'), 0);
    }
  });

  function updateLineItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount();
        renderCart(cart);
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  window.openCartDrawer = openCartDrawer;
})();


/* === QUICK VIEW MODAL === */
(function () {
  var modal    = document.getElementById('quickview-modal');
  var overlay  = document.getElementById('quickview-overlay');
  var closeBtn = document.getElementById('quickview-close');
  var body     = document.getElementById('quickview-body');
  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    playClick();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    playClick();
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quickview]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-quickview');
    if (!handle) return;
    body.innerHTML = '<div class="quickview-modal__img-placeholder"></div><div class="quickview-modal__info"><p class="cart-drawer__loading">—</p></div>';
    openModal();
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) { renderQuickView(product); })
      .catch(function () {
        body.innerHTML = '<div style="padding:3rem;text-align:center;font-size:0.75rem;letter-spacing:0.15em;text-transform:uppercase;color:var(--text-muted)">Could not load product.</div>';
      });
  });

  function renderQuickView(product) {
    var img = product.featured_image;
    var imgHtml = img
      ? '<img class="quickview-modal__img" src="' + img + '" alt="' + esc(product.title) + '" loading="eager">'
      : '<div class="quickview-modal__img-placeholder"></div>';

    var firstVariant = product.variants[0];
    var variantDefault = firstVariant.id;
    var hasVariants = product.variants.length > 1 || firstVariant.title !== 'Default Title';
    var variantHtml = hasVariants
      ? (function () {
          var s = '<select class="variant-select" id="qv-variant">';
          product.variants.forEach(function (v) {
            s += '<option value="' + v.id + '" data-price="' + v.price + '" data-available="' + (v.available ? '1' : '0') + '"' +
              (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + (v.available ? '' : ' — Sold Out') + '</option>';
          });
          return s + '</select>';
        })()
      : '<input type="hidden" id="qv-variant" value="' + variantDefault + '">';

    body.innerHTML =
      imgHtml +
      '<div class="quickview-modal__info">' +
      '<h2 class="quickview-modal__title">' + esc(product.title) + '</h2>' +
      '<div class="quickview-modal__price" id="qv-price">' + fmtMoney(firstVariant.price) + '</div>' +
      variantHtml +
      '<button class="btn btn--full" id="qv-atc" type="button"' + (firstVariant.available ? '' : ' disabled') + '>' +
      (firstVariant.available ? 'ADD TO CART' : 'SOLD OUT') + '</button>' +
      '<a href="/products/' + esc(product.handle) + '" class="quickview-modal__view-link">VIEW FULL DETAILS →</a>' +
      '</div>';

    var priceEl = document.getElementById('qv-price');
    var variantSelect = document.getElementById('qv-variant');
    if (variantSelect && priceEl) {
      variantSelect.addEventListener('change', function () {
        var opt = this.options[this.selectedIndex];
        priceEl.textContent = fmtMoney(parseInt(opt.getAttribute('data-price'), 10));
        var atcBtn = document.getElementById('qv-atc');
        if (atcBtn) {
          var avail = opt.getAttribute('data-available') === '1';
          atcBtn.disabled = !avail;
          atcBtn.textContent = avail ? 'ADD TO CART' : 'SOLD OUT';
        }
      });
    }

    var atcBtn = document.getElementById('qv-atc');
    if (atcBtn && firstVariant.available) {
      atcBtn.addEventListener('click', function () {
        var select = document.getElementById('qv-variant');
        var id = select ? select.value : variantDefault;
        atcBtn.disabled = true;
        atcBtn.textContent = '. . .';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 }),
        })
          .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
          .then(function () {
            atcBtn.textContent = 'ADDED —';
            updateCartCount();
            setTimeout(function () {
              closeModal();
              if (window.openCartDrawer) window.openCartDrawer();
            }, 600);
          })
          .catch(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = 'TRY AGAIN';
          });
      });
    }
  }

  function fmtMoney(cents) {
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
})();


/* === PRODUCT IMAGE GALLERY === */
(function () {
  var mainImg = document.getElementById('product-gallery-main');
  if (!mainImg) return;
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-src]');
    if (!thumb) return;
    document.querySelectorAll('[data-gallery-src]').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    mainImg.style.opacity = '0';
    setTimeout(function () {
      mainImg.src = thumb.getAttribute('data-gallery-src');
      mainImg.alt = thumb.getAttribute('data-gallery-alt') || '';
      mainImg.style.opacity = '1';
    }, 160);
  });
})();


/* === STICKY ATC BAR === */
(function () {
  var stickyBar  = document.getElementById('sticky-atc');
  var mainAtcBtn = document.getElementById('add-to-cart-btn');
  var stickyBtn  = document.getElementById('sticky-atc-btn');
  if (!stickyBar || !mainAtcBtn) return;

  function onScroll() {
    var rect = mainAtcBtn.getBoundingClientRect();
    var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    stickyBar.classList.toggle('is-visible', outOfView);
    stickyBar.setAttribute('aria-hidden', outOfView ? 'false' : 'true');
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var form = document.getElementById('add-to-cart-form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }
})();


/* === NEWSLETTER FORM === */
var newsletterForms = document.querySelectorAll('.newsletter__form');
newsletterForms.forEach(function (form) {
  form.addEventListener('submit', function (e) {
    var successMsg = form.parentElement.querySelector('.newsletter__success');
    if (!successMsg) return;

    e.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    fetch(form.getAttribute('action') || '/contact', {
      method:      'POST',
      body:        new FormData(form),
      credentials: 'same-origin',
      headers:     { 'Accept': 'text/html' },
    }).then(function (res) {
      if (!res.ok && !res.redirected) throw new Error('Newsletter submission failed');

      form.reset();
      form.style.display       = 'none';
      successMsg.style.display = 'block';
    }).catch(function () {
      // Let Shopify handle the form normally only if the AJAX request truly fails.
      form.submit();
    });
  });
});


/* === PRODUCT CAROUSEL === */
(function () {
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.product-carousel__arrow');
    if (!arrow) return;

    var track = arrow.closest('.product-carousel').querySelector('.product-carousel__track');
    if (!track) return;

    var itemWidth = track.querySelector('.product-carousel__item').offsetWidth;
    var direction = arrow.classList.contains('product-carousel__arrow--next') ? 1 : -1;
    track.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
  });
})();


/* === EMAIL POPUP === */
(function () {
  var STORAGE_KEY = 'orison_popup_seen';
  var DELAY_MS    = 4000;

  if (localStorage.getItem(STORAGE_KEY)) return;

  var overlay  = document.getElementById('email-popup-overlay');
  var closeBtn = document.getElementById('email-popup-close');
  var skipBtn  = document.getElementById('email-popup-skip');
  var form     = document.getElementById('email-popup-form');
  var success  = document.getElementById('email-popup-success');

  if (!overlay) return;

  function openPopup() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    localStorage.setItem(STORAGE_KEY, '1');
  }

  setTimeout(openPopup, DELAY_MS);

  closeBtn.addEventListener('click', closePopup);
  skipBtn.addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var emailInput = form.querySelector('input[type="email"]');
    if (!emailInput.value || !emailInput.validity.valid) {
      emailInput.focus();
      return;
    }

    var submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = '—';

    var body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', emailInput.value);
    body.append('contact[tags]', 'newsletter,welcome-popup');

    fetch('/contact', {
      method:      'POST',
      body:        body,
      credentials: 'same-origin',
      headers:     { 'Accept': 'text/html' },
    }).finally(function () {
      form.style.display    = 'none';
      success.style.display = 'block';
      localStorage.setItem(STORAGE_KEY, '1');
    });
  });
})();
